import { render, staticRenderFns } from "./IndexDependencyWarning.vue?vue&type=template&id=e070c770&scoped=true"
import script from "./IndexDependencyWarning.vue?vue&type=script&lang=js"
export * from "./IndexDependencyWarning.vue?vue&type=script&lang=js"
import style0 from "./IndexDependencyWarning.vue?vue&type=style&index=0&id=e070c770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e070c770",
  null
  
)

export default component.exports